enum LanguageCode {
  DE = 'de',
  FR = 'fr',
}

export {
  LanguageCode,
};
